import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  submitForm() {
    this.element.requestSubmit();
  }

  submitInput() {
    this.element.form.requestSubmit();
    this.element.parentNode.innerHTML = `<div class="flex items-center justify-center">
      <div class="h-6 w-6 rounded-full border-4 border-t-4 border-gray-50 border-t-orange-700 animate-spin"></div>
    </div>`
  }

  submitNoLoaderInput() {
    this.element.form.requestSubmit();
  }
}